import { Box, BoxProps, ColorOptions, Spacer, Text, TextProps } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/native'
import { FC, MutableRefObject, useCallback, useEffect, useRef, useState } from 'react'
import { InjectIframe } from '../../comps/InjectIframe'
import { Modal } from '../../comps/Modal'
import { useLazyApiData, useStores } from '../../data/store'
import { getWindow, isIFrame } from '../../utils'
import { ChildWindow } from './ChildWindow'
import { FoodCardProcessing } from './FoodCardProcessing'

interface Props {
  setShow: any
  show: boolean
  title?: string
  isFoodCard?: boolean
  sendCallBackToNative?: boolean
  closeReview?: any
}

export const MobileProcessing: FC<Props> = ({
  show: showModal = false,
  title,
  setShow: setShowModal,
  isFoodCard = false,
  sendCallBackToNative = false,
  closeReview,
}) => {
  const {
    confirmPayment,
    returnurl,
    theme,
    isSubscriptionTxn,
    updateShowPopup,
    cancelIntent,
    txnId,
    intentId,
    updateShowBackPopup,
    method,
    redirectHtml,
    paymentType,
  } = useStores((root) => ({
    confirmPayment: root.confirmPaymentApi,
    returnurl: root.transaction.getMerchantRedirectingUrl(),
    payLoad: root?.transaction?.txnMeta?.payLoad ?? {},
    method: root?.transaction?.txnMeta?.method,
    redirectHtml: root?.transaction?.txnMeta?.redirectHtml,
    theme: root?.config?.merchantTheme,
    isSubscriptionTxn: root?.isSubscriptionTxn,
    updateShowPopup: root.config.updateShowPopup,
    cancelIntent: root.cancelIntentApi,
    txnId: root.transaction.id.id,
    intentId: root.transaction.id.intentId,
    updateShowBackPopup: root.config.updateShowBackPopup,
    paymentType: root.getPaymentType(),
  }))
  const child: MutableRefObject<Window | null> = useRef(null)

  const styles = processingStyles(theme, isFoodCard)
  const { goBack, canGoBack } = useNavigation()
  const [confirmPaymentApi, { state: confirmPaymentState, data: confirmPaymentData }] = useLazyApiData(confirmPayment)
  const [lazyCancelIntent, { state: cancelIntentState }] = useLazyApiData(cancelIntent)
  const { REACT_APP_URL = '' } = process.env
  const windowClosed = () => window.currentChild?.closed
  const [iframeUrl, setIframeUrl] = useState<String>('')

  const getRootUrl = (url: string) => {
    const pathArray = url.split('/')
    const host = pathArray[2]
    return host
  }

  const shouldShowInjectIframe = paymentType === 'Card' && redirectHtml && iframeUrl !== getRootUrl(REACT_APP_URL)

  useEffect(() => {
    if (showModal) {
      confirmPaymentApi()
    }
  }, [confirmPaymentApi, showModal])

  const NavigateToMerchant = useCallback(() => {
    // Linking.openURL(retUrl)
    window.location.href = returnurl
  }, [returnurl])

  useEffect(() => {
    if (cancelIntentState === 'fulfilled' || cancelIntentState === 'rejected') {
      if (isIFrame()) {
        window.parent.postMessage(
          {
            txnId,
            intentId,
            status: 'cancelled',
            message: '',
          },
          '*',
        )
      } else {
        NavigateToMerchant()
      }
    }
  }, [NavigateToMerchant, cancelIntentState, intentId, txnId])

  useEffect(() => {
    if (confirmPaymentState === 'rejected') {
      if (sendCallBackToNative && getWindow().JioPaymentWebViewInterface) {
        getWindow().JioPaymentWebViewInterface.postMessage(
          JSON.stringify({
            event: 'ON_BANK_FORM_FAILED',
            data: {
              error: confirmPaymentData?.message,
              transactionId: txnId,
            },
          }),
        )
      }
      if (!windowClosed()) {
        window.currentChild?.close()
        setShowModal(false)
        isSubscriptionTxn() && closeReview && closeReview()
        if (isSubscriptionTxn() && canGoBack() && confirmPaymentData?.message === '') {
          updateShowPopup(false)
          goBack()
        }
      } else {
        lazyCancelIntent()
      }
    } else if (confirmPaymentState === 'fulfilled') {
      if (sendCallBackToNative && getWindow().JioPaymentWebViewInterface) {
        getWindow().JioPaymentWebViewInterface.postMessage(
          JSON.stringify({
            event: 'ON_BANK_FORM_RECEIVED',
            data: {
              error: confirmPaymentData?.message,
              transactionId: txnId,
            },
          }),
        )
      }
      updateShowBackPopup(false)
      if (windowClosed() && !shouldShowInjectIframe) {
        lazyCancelIntent()
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [canGoBack, confirmPaymentState, goBack, isSubscriptionTxn, setShowModal, updateShowPopup])

  const onCancelFoodCardPayment = () => {
    setShowModal(false)
    window.currentChild?.close()
  }

  const onIframeUrlChange = useCallback(
    (url) => {
      setIframeUrl(getRootUrl(url))
      console.log('htag getRootUrl', getRootUrl(url))
      console.log('htag getRoot returnUrl', getRootUrl(REACT_APP_URL))
      if (getRootUrl(url) === getRootUrl(REACT_APP_URL)) {
        if (isIFrame()) {
          window.parent.postMessage(
            {
              txnId,
              intentId,
              status: 'completed',
              message: '',
              rUrl: returnurl,
            },
            '*',
          )
        } else {
          //Linking.openURL(retUrl)
          window.location.href = returnurl
        }
      }
    },
    [REACT_APP_URL, intentId, returnurl, txnId],
  )

  return (
    <Modal type="Bottom" show={showModal} title={title} isFullWidth={true} headerType={'White_Bg'}>
      <Box {...styles.container}>
        {(paymentType !== 'Card' || (!redirectHtml && paymentType === 'Card')) && (
          <ChildWindow hide={method ? false : true} retUrl={returnurl} childRef={child} />
        )}
        {shouldShowInjectIframe && (
          <InjectIframe
            onUrlChange={onIframeUrlChange}
            htmlScript={redirectHtml as any}
            show={shouldShowInjectIframe}
            theme={theme}
          />
        )}{' '}
        <Spacer direction="vertical" size={32} />
        {isFoodCard ? (
          <FoodCardProcessing styles={styles} theme={theme} isLoading={true} onCancel={onCancelFoodCardPayment} />
        ) : (
          <PaymentProcessing styles={styles} theme={theme} />
        )}
        <Spacer direction="vertical" size={32} />
      </Box>
    </Modal>
  )
}

const PaymentProcessing = ({ styles, theme }: any) => {
  const handlePayment = () => {
    if (window.currentChild) {
      window.currentChild.focus()
    }
  }
  return (
    <>
      <Text
        testID="processing-state"
        value="Processing the payment please wait..."
        fontSize={16}
        fontFamily="jioType-Medium"
        color={theme?.bodyTextColor as ColorOptions}
      />
      <Spacer direction="vertical" size={24} />
      {isIFrame() && (
        <>
          <Box width="100%" height={8} bg={theme?.brandColor as ColorOptions} borderRadius={12} />
          <Spacer direction="vertical" size={32} />
          <Box
            testID="back-to-payment"
            onPress={handlePayment}
            underlayColor="LIGHTEST_GREY"
            padding={8}
            borderRadius={10}>
            <Text value="Go Back To Payment" {...styles?.buttonText} />
          </Box>
        </>
      )}
    </>
  )
}

const shadow = {
  shadowColor: '#00000029',
  shadowOffset: {
    width: 0,
    height: 1,
  },
  shadowOpacity: 1,
  shadowRadius: 0,
}

const processingStyles = (theme: any, isFoodCard: boolean) => ({
  container: {
    bg: theme?.bodyBgColor as ColorOptions,
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: isFoodCard ? 8 : 24,
    paddingVertical: 8,
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
  } as BoxProps,
  buttonText: {
    fontFamily: 'jiotype-medium',
    fontSize: 14,
    color: theme?.brandColor as ColorOptions,
    fontWeight: '500',
  } as TextProps,
  retryContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  } as BoxProps,
  retryText: {
    marginVertical: 16,
  } as BoxProps,
  leftContainer: {
    justifyContent: 'space-around',
    direction: 'row',
  } as BoxProps,
  cardIconContainer: (isLargeScreen: boolean) =>
  ({
    borderRadius: isLargeScreen ? '8px' : '4px',
    width: isLargeScreen ? '60px' : '40px',
    height: isLargeScreen ? '40px' : '40px',
    justify: 'center',
    align: 'center',
    borderWidth: 1,
    marginTop: 16,
    borderColor: 'BRAND_COLOR_GRAY_3',
    ...shadow,
  } as BoxProps),
  closeIconBox: {
    justifyContent: 'flex-end',
    marginTop: 8,
    marginLeft: 16,
    width: 16,
    height: 16,
    underlayColor: 'TRANSPARENT',
  } as BoxProps,
  errorModalText: {
    fontSize: 14,
    fontFamily: 'jioType-Medium',
    color: theme.bodyTextColor,
    textAlign: 'center',
  } as TextProps,
})
